// vim: set ts=2 sts=2 sw=2 et:
//
// Al reabrir desde la web un torneo que ya está cargado, el bundle fresco trae anchors con los ids de
// SUS entries. Los ids locales coinciden solo si nadie re-numeró: "Unir tarimas" y "Recuperar de la
// web" lo hacen, y entonces adoptar los anchors por id dejaba a los atletas fusionados sin anchor o,
// peor, con el de otro inscripto que reusó el id. Acá cada anchor fresco se re-asocia por identidad
// (inscripción → DNI → nombre, con el equipamiento), igual que "Traer cambios de la web".

import type { Entry } from "../../types/dataTypes";
import type { OpenlifterBundleFile, WrpfEntryAnchor } from "./types";
import { identityKeys } from "./pullFromWeb";

type Fresh = { entryId: number; anchor: WrpfEntryAnchor };

export function remapEntryAnchors(args: {
  localEntries: ReadonlyArray<Entry>;
  localAnchors: ReadonlyArray<WrpfEntryAnchor>;
  incoming: OpenlifterBundleFile;
}): WrpfEntryAnchor[] {
  const incomingAnchors = new Map((args.incoming._wrpf?.entryAnchors ?? []).map((a) => [a.openlifterEntryId, a]));
  const localAnchors = new Map(args.localAnchors.map((a) => [a.openlifterEntryId, a]));

  const byUot = new Map<string, Fresh>();
  const byDni = new Map<string, Fresh | null>();
  const byName = new Map<string, Fresh | null>();
  for (const entry of args.incoming.registration.entries as Entry[]) {
    const anchor = incomingAnchors.get(entry.id);
    if (!anchor) continue;
    const keys = identityKeys(entry, anchor);
    const item = { entryId: entry.id, anchor };
    if (keys.uot) byUot.set(keys.uot, item);
    // Una clave repetida no identifica a nadie: se anula.
    if (keys.dni) byDni.set(keys.dni, byDni.has(keys.dni) ? null : item);
    if (keys.name) byName.set(keys.name, byName.has(keys.name) ? null : item);
  }

  const used = new Set<number>();
  const result: WrpfEntryAnchor[] = [];
  for (const local of args.localEntries) {
    const localAnchor = localAnchors.get(local.id);
    const keys = identityKeys(local, localAnchor);
    const match =
      (keys.uot ? byUot.get(keys.uot) : undefined) ??
      (keys.dni ? byDni.get(keys.dni) : undefined) ??
      (keys.name ? byName.get(keys.name) : undefined);
    if (match && !used.has(match.entryId)) {
      used.add(match.entryId);
      result.push({ ...match.anchor, openlifterEntryId: local.id });
    } else if (localAnchor) {
      // La web ya no tiene esa inscripción (baja, cambio de equipamiento): se conserva la local.
      result.push(localAnchor);
    }
  }
  return result;
}
